import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { Logo } from './Logo';

const metiersLinks = [
  { id: 'btp', label: 'BTP & Génie Civil' },
  { id: 'mecanique-hydraulique', label: 'Mécanique & Hydraulique' },
  { id: 'location', label: 'Location de Matériel' },
];

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [metiersOpen, setMetiersOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    } else {
      const element = document.getElementById(sectionId);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
    setMetiersOpen(false);
  };

  const linkClass = 'text-gray-700 hover:text-green-600 transition-colors font-medium';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20 md:h-24">
          <a href="/" className="flex items-center">
            <Logo showText={true} size="default" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-7">
            <button onClick={() => scrollToSection('accueil')} className={linkClass} data-testid="nav-accueil">Accueil</button>
            <button onClick={() => scrollToSection('apropos')} className={linkClass} data-testid="nav-apropos">À propos</button>

            {/* Nos Métiers dropdown */}
            <div className="relative" onMouseEnter={() => setMetiersOpen(true)} onMouseLeave={() => setMetiersOpen(false)}>
              <button className={`${linkClass} flex items-center gap-1`} data-testid="nav-metiers">
                Nos Métiers <ChevronDown className="h-4 w-4" />
              </button>
              {metiersOpen && (
                <div className="absolute top-full left-0 pt-2 w-64" data-testid="metiers-dropdown">
                  <div className="bg-white rounded-lg shadow-xl border border-gray-100 py-2">
                    {metiersLinks.map((m) => (
                      <button
                        key={m.id}
                        onClick={() => scrollToSection(m.id)}
                        className="block w-full text-left px-4 py-2.5 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors"
                        data-testid={`nav-metier-${m.id}`}
                      >
                        {m.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <button onClick={() => scrollToSection('produits')} className={linkClass} data-testid="nav-produits">Produits & Services</button>
            <button onClick={() => navigate('/actualites')} className={linkClass} data-testid="nav-actualites">Actualités</button>
            <Button onClick={() => scrollToSection('contact')} className="bg-green-600 hover:bg-green-700 text-white" data-testid="nav-contact">Contact</Button>
          </nav>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="lg:hidden p-2" data-testid="mobile-menu-toggle">
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-gray-200" data-testid="mobile-nav">
            <div className="flex flex-col gap-3">
              <button onClick={() => scrollToSection('accueil')} className={`text-left ${linkClass}`}>Accueil</button>
              <button onClick={() => scrollToSection('apropos')} className={`text-left ${linkClass}`}>À propos</button>

              <div>
                <button onClick={() => setMetiersOpen(!metiersOpen)} className={`text-left flex items-center gap-1 ${linkClass}`}>
                  Nos Métiers <ChevronDown className={`h-4 w-4 transition-transform ${metiersOpen ? 'rotate-180' : ''}`} />
                </button>
                {metiersOpen && (
                  <div className="flex flex-col gap-2 pl-4 mt-2 border-l-2 border-green-200">
                    {metiersLinks.map((m) => (
                      <button key={m.id} onClick={() => scrollToSection(m.id)} className="text-left text-sm text-gray-600 hover:text-green-600">
                        {m.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <button onClick={() => scrollToSection('produits')} className={`text-left ${linkClass}`}>Produits & Services</button>
              <button onClick={() => navigate('/actualites')} className={`text-left ${linkClass}`}>Actualités</button>
              <Button onClick={() => scrollToSection('contact')} className="bg-green-600 hover:bg-green-700 text-white w-full">Contact</Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
